module.exports = "/assets/b3082b56a51cb6a7972dfe3de5844a53.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/BM.png
// module id = 2364
// module chunks = 0